import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    competencytitleindicators:[]
}

export const fetchCompetencyTitleIndicator = createAsyncThunk('competencytitleindicator/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/competencyTitleIndicator`)
    return response.data
  })

  export const fetchUserRoleIndicator = createAsyncThunk('competencytitleindicator/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/competencyTitleIndicator`)
    return response.data
  })

let userSlice = createSlice({
  name:'competencytitleindicator',//Root Reducer Name
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchCompetencyTitleIndicator.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchCompetencyTitleIndicator.fulfilled,(state,action)=>{
          state.isLoading = false
          state.competencytitleindicators = action.payload
      })
      .addCase(fetchCompetencyTitleIndicator.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;